import { useMutation, useQueryClient } from "react-query";

import { QUERY_STRINGS } from "../../constants";
import usersService from "../../services/users";
import { SnackbarState, useSnackbar } from "../../store/useSnackbar";
import { ErrorContent } from "../../types/default";
import { UserRoles } from "../../types/users";

const addSnackbarSelector = (state: SnackbarState) => state.addSnackbar;

export const useEditUser = (user: UserRoles) => {
  const addSnackbar = useSnackbar(addSnackbarSelector);

  const queryClient = useQueryClient();

  const { mutate: editUser, isLoading } = useMutation(
    user === UserRoles.manager ? usersService.editManager : usersService.editSuperadmin,
    {
      mutationKey: QUERY_STRINGS.EDIT_USER,
      onError: (error: ErrorContent) => addSnackbar({ text: error.message }),
      onSuccess: () => queryClient.invalidateQueries([QUERY_STRINGS.GET_MANAGERS, QUERY_STRINGS.GET_SUPERADMINS]),
    }
  );

  return { editUser, isLoading };
};
